import React from "react";
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";
import '../general/General.css';
import { useNavigate } from "react-router-dom";
import { useCheckAccess } from "../../utils/Utilities";
import DonationStatement from "../money/DonationStatement";
import { useSelector } from "react-redux";
const DonationAdmin = () => {
  useCheckAccess('DonationRW,StatementsRO'); // Check if the user is logged in (if no user data, redirect to login)
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  return (
    <>
      <Navbar />
      <Helmet>
        <title>ஸ்ரீ பொன்னாச்சி அம்மன் திருக்கோவில்கள் | Donation Admin</title>
        <link rel="canonical" href="/donation" />
      </Helmet>
      <>
        {user?.roles?.includes('DonationRW') && (
          <div className="general_parent">
            <div className="general_container">
              <div className="general_body">
                <Breadcrumbs /><br />
                <button onClick={() => navigate("/donation/create")}>புதிய நன்கொடை சேகரிப்பு</button>
                <button onClick={() => navigate("/donation/create-guest")}>புதிய விருந்தினர் நன்கொடை சேகரிப்பு</button>
                <br />
              </div>
            </div>
          </div>
        )}
        <div className="general_parent">
          <div className="general_container">
            <div className="general_body">
              <Breadcrumbs /><br />
              <DonationStatement />
            </div>
          </div>
        </div>
      </>
      <br />
      <Footer />
    </>
  );
};

export default DonationAdmin;
